import {SxType} from "@baseTypes/sx/sxTypes";

export const sx: SxType = {
    root: {
        width: '100%',
        // The modal is narrow by default - the stop-list fields inside it get
        // squeezed down to something unreadable.
        minWidth: {xs: 'auto', sm: '460px'},
        maxWidth: '640px',
        display: 'flex',
        flexDirection: 'column',
        padding: '4px 0 0',
        alignItems: 'flex-start',
        gap: '14px',
    },
    section: {
        width: '100%',
        display: 'flex',
        flexDirection: 'column',
        gap: '12px',
    },
    name: {
        fontSize: '16px',
        fontWeight: '600',
        '.lightTheme &': {
            color: '#222'
        }
    },
    btn: {
        textTransform: 'initial'
    },
    divider: {
        width: '100%'
    },
    inner: {
        width: '100%'
    },
    icon: {},
    hints: {
        width: '100%',
        display: 'flex',
        flexWrap: 'wrap',
        gap: '6px',
    },
    hint: {
        fontSize: '11px',
        lineHeight: '18px',
        padding: '0 8px',
        borderRadius: '9px',
        border: '1px solid rgba(255,255,255,0.25)',
        opacity: 0.85,
        '.lightTheme &': {
            borderColor: 'rgba(0,0,0,0.2)',
            color: '#333',
        }
    },
    footer: {
        width: '100%',
        display: 'flex',
        justifyContent: 'flex-end',
        alignItems: 'center',
        gap: '10px',
        paddingTop: '4px',
    },
}
